import { useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { FormResponses, TableColumnType } from 'modules/forms'
import { TrainingFormContextType } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/TrainingFormDetail/types'

const Answers = () => {
  const { trainingForm } = useOutletContext<TrainingFormContextType>()
  return (
    <Box className="pt-4">
      <FormResponses
        formId={trainingForm.id.toString()}
        isFormAnonymous={!!trainingForm.anonymous}
        columns={[
          TableColumnType.Participant,
          TableColumnType.RelatedResource,
          TableColumnType.Status,
          ...(trainingForm.formType === 'effectiveness' ? [TableColumnType.Evaluator] : []),
          ...(trainingForm.formType === 'knowledge'
            ? [TableColumnType.FinalResult, TableColumnType.FinalScore]
            : []),
        ]}
        filters={['relatedResource']}
        relatedResourceLabel={i18n.t('common.group')}
        resourceType="Trainings::Training"
        materializedFormResourceType="Trainings::TrainingClass"
        resourceHeaderModule={{
          id: 'my_trainings',
          label: 'Trainings',
          href: '/trainings',
        }}
      />
    </Box>
  )
}

export default Answers
